module.exports = __webpack_public_path__ + "img/on-the-go-people.a51d67de.jpg";